import React from "react";
import { Route } from "react-router";
import Private from "./Private";
import NotAllowed from "../../containers/NotAllowed/NotAllowed";

/**
 * Route component with Private base
 * See Private component
 *
 * @param props
 * @returns {*}
 */
export default props => {
  const { notAllowed = NotAllowed, ...remainingProps } = props;

  return <Private As={Route} Or={notAllowed} {...remainingProps} />;
};



// WEBPACK FOOTER //
// ./src/components/Private/PrivateRoute.js